<template>
<div class="chapter">
<div class="inner_page">
<p class="center-para2"><a id="page_ii"></a>Also by Darnella Ford</p>
<p class="para"> </p>
<p class="center-para"><em>Crave</em></p>
<p class="center-para"><em>Rising</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?1a5af645